// extracted by mini-css-extract-plugin
module.exports = {"alp":"elevations_alp__eNcS_","tln":"elevations_tln___2BVj","btl":"elevations_btl__KVw5Q"};